import axios from 'axios';

const putData = config => {
  return axios.put(config.url);
};

export default putData;

